import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import Headline from '../../../atoms/headline/headline';
import EducationNumber from '../../../atoms/education/number/educationNumber';
import MixedCopy from '../../mixed-copy/mixedCopy';
import FullscreenMedia from '../../fullscreen-media/fullscreenMedia';
import StyledEducationStep from './educationStep.style';

const Image = dynamic(() => import(/* webpackChunkName: "image" */ '../../../atoms/image/image'));

const EducationStep = ({
  headline,
  copy,
  topics,
  contentType,
  number,
  image,
  videoId,
  previewImage,
  hoster
}) => {
  return (
    <StyledEducationStep>
      <div className="step-headline">
        {number && (
          <div className="step-headline__number">
            <EducationNumber contentType={contentType} category={topics} number={number} />
          </div>
        )}
        {headline && <Headline className="step-headline__text">{headline}</Headline>}
      </div>
      <div className="step-content">
        {!videoId && image && <Image className="step-content__image" {...image} lazy="default" />}
        {videoId && (
          <FullscreenMedia
            type="embeddedVideo"
            hoster={hoster}
            videoId={videoId}
            previewImage={previewImage}
          />
        )}

        {copy && <MixedCopy html={copy} fullWidth />}
      </div>
    </StyledEducationStep>
  );
};

EducationStep.propTypes = {
  headline: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  contentType: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    })
  ).isRequired,
  number: PropTypes.number.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  videoId: PropTypes.string,
  previewImage: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  hoster: PropTypes.string
};

export default EducationStep;
